import { Import } from "@/types/Import";
import { cn } from "@/lib/utils";
import { CheckCircle, RefreshCw, XCircle, AlertCircle } from "lucide-react";
import { Show } from "@/components/core";

interface ImportStatusIndicatorProps {
  importItem: Import | undefined;
}

export const ImportStatusIndicator = (props: ImportStatusIndicatorProps) => {
  const importItem = props.importItem;
  if (!importItem) {
    return null;
  }
  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium",
        importItem.status === "Finished" && "bg-green-100 text-green-800",
        importItem.status === "InProgress" && "bg-blue-100 text-blue-800",
        importItem.status === "Failed" && "bg-red-100 text-red-800",
        importItem.status === "FinishedWithErrors" &&
          "bg-yellow-100 text-yellow-800",
        importItem.status === "Started" && "bg-blue-100 text-blue-800"
      )}
    >
      {importItem.status === "Finished" && (
        <CheckCircle className="h-3 w-3 mr-1" />
      )}
      {importItem.status === "InProgress" && (
        <RefreshCw className="h-3 w-3 mr-1 animate-spin" />
      )}
      {importItem.status === "Failed" && <XCircle className="h-3 w-3 mr-1" />}
      {importItem.status === "FinishedWithErrors" && (
        <AlertCircle className="h-3 w-3 mr-1" />
      )}
      {importItem.status === "Started" && (
        <RefreshCw className="h-3 w-3 mr-1 animate-spin" />
      )}
      {importItem.status}
      <Show if={importItem.percentCompleted !== undefined}>
        <span className="ml-2 text-xs text-gray-500">
          {importItem.percentCompleted}%
        </span>
      </Show>
    </span>
  );
};
